import { ToastrService } from 'ngx-toastr';

import { ServicioService } from '../servicio/servicio.service';
import { ICombo } from '../nucleo/interface/form/ICombo';
import { SettingService } from '../nucleo/configuracion/setting.service';
import { AutenticacionService } from '../seguridad/autenticacion.service';
import { IDocumentoDto } from '../nucleo/interface/dto/IDocumentoDto';

export class CommonComponent {
  public documentoDto: IDocumentoDto;
  public estados: ICombo;
  public tableData: Array<unknown> = [];
  public showGeneralProgres: boolean;
  public mensage: any;
  public totalElements = 0;
  public pagina = 0;
  public tamanioPagina = 10;
  private date = new Date();
  private tomorrow = new Date();

  constructor(public service: ServicioService, 
              public toastr: ToastrService,
              public loginService: AutenticacionService,
              public settingService: SettingService) {
    
    this.tomorrow.setDate(this.tomorrow.getDate()+1);
    this.documentoDto = {
      nombreDocumento: '',
      numeroExpediente: '',
      fechaCreacionInicio: { date: { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() } },
      fechaCreacionFin: { date: { year: this.tomorrow.getFullYear(), month: this.tomorrow.getMonth() + 1, day: this.tomorrow.getDate()} },
      codigoEstado:''
    }
  }

  limpiar(tipo?: string) {
    switch (tipo) {
      case '1':
        this.documentoDto = { 
          codigoEstado: '',
          fechaCreacionInicio: { date: { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() } },
          fechaCreacionFin: { date: { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() + 1 } },
         }
        this.tableData = [];
        this.totalElements = 0;
        break;
      case '2':
        break;
      case '3':
        break;
      default:
        break;
    }
  }

  setOptionsToat() {
    return {
      timeOut: 10000,
      progressBar: true,
      closeButton: true
    }
  }
}